export const standardPaths = {
    list: () => 'admin/standards',
    detail: id => `admin/standards/${id}`,
    versions: id => `admin/standards/${id}/versions`,
    version: id => `admin/standard-versions/${id}`,
    sections: id => `admin/standard-versions/${id}/sections`,
    section: id => `admin/standard-sections/${id}`,
    members: id => `admin/standard-versions/${id}/members`,
    member: (id, memberId) => `admin/standard-versions/${id}/members/${memberId}`,
    resolved: id => `admin/standard-versions/${id}/resolved`,
    publish: id => `admin/standard-versions/${id}/publish`,
};
